import { createElement, createElementNS, removeElement } from '../functions/dom'
import { ITEM_STATE_PLAYED, ITEM_STATE_PLAYING } from '../vars/itemStatus'
import { getWidgetData, saveWidgetData } from '../functions/widgetsData'
import { proseMirrorYjsPlugins } from '../functions/proseMirrorYjsPlugins'
import { getPmMenuPosition } from '../functions/getPmMenuPosition'

const gravatar = require('gravatar')

const cookieFetch = require('../functions/cookieFetch')
const getMeta = require('../functions/getMeta')

window.getPrepIdName = id => 'prep-' + id

window.focusPrep = id => {
    const prep = document.getElementById(getPrepIdName(id))
    if (prep) {
        prep.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
}

const transNameMeta = {}

function getTrans (transName) {
    if (!transNameMeta[transName]) {
        transNameMeta[transName] = getMeta('trans_' + transName)
    }
    return transNameMeta[transName]
}

const itemFieldRegex = /^item\./

export class RundownPrepItem extends HTMLElement {

    constructor () {
        super()

        // Bind functions
        this.yTitleToItemTitle = this.yTitleToItemTitle.bind(this)
        this.itemTitleToYTitle = this.itemTitleToYTitle.bind(this)
        this.yStartToItemStart = this.yStartToItemStart.bind(this)
        this.toggleStatusCheckbox = this.toggleStatusCheckbox.bind(this)
        this.observeYTitle = this.observeYTitle.bind(this)
        this.openEdit = this.openEdit.bind(this)
        this.yObserve = this.yObserve.bind(this)
        this.yWidgetObserve = this.yWidgetObserve.bind(this)
        this.updateDurationInYjs = this.updateDurationInYjs.bind(this)
        this.setDurationInItem = this.setDurationInItem.bind(this)
        this.toggleHideDescription = this.toggleHideDescription.bind(this)
        this.calculateOverTime = this.calculateOverTime.bind(this)
        this.calculateDurationOverTime = this.calculateDurationOverTime.bind(this)
        this.observeContact = this.observeContact.bind(this)
        this.updateProseMirrorMenuPosition = this.updateProseMirrorMenuPosition.bind(this)

        // Create debounce's
        this.updateProseMirrorMenuPositionDebounce = _.debounce(this.updateProseMirrorMenuPosition, 100, { maxWait: 2000 })
        this.observeItemTitle = _.debounce(this.itemTitleToYTitle, 500, { maxWait: 500 })
        this.debounceDurationOverTime = _.debounce(this.calculateDurationOverTime, 500)
        this.debounceUpdateDurationInYjs = _.debounce(this.updateDurationInYjs, 500)
        this.debouncePlaceItemDuration = _.debounce(this.setDurationInItem, 500)
        this.debouncePlaceItemStart = _.debounce(this.yStartToItemStart, 500)
        this.debouncePlaceItemTitle = _.debounce(this.yTitleToItemTitle, 500)
        this.debounceOverTime = _.debounce(this.calculateOverTime, 500)

        // Create elements
        this.itemTypeElement = createElement('div', {
            class: this.generateClassName('type'),
        })

        this.itemContentElement = createElement('div', {
            class: this.generateClassName('Content'),
            children: [

                createElement('div', {
                    class: this.generateClassName('Title'),
                    children: [

                        createElementNS('svg', {
                            class: this.generateClassName('SpeakArrow'),
                            viewBox: '0 0 15 61',
                            version: '1.1',
                            children: [
                                createElementNS('polygon', {
                                    fill: `var(${this.generateCssVarName('color')})`,
                                    transform: 'translate(7.5, 30.5) rotate(90) translate(-7.5, -30.5)',
                                    points: '7.5 23 38 38 -23 38',
                                }, 'http://www.w3.org/2000/svg'),
                            ],
                        }, 'http://www.w3.org/2000/svg'),

                        this.itemStatusContainer = createElement('div', {
                            class: this.generateClassName('ItemStatus'),
                            onclick: this.toggleStatusCheckbox,
                            children: [
                                createElement('div', {
                                    class: ['material-icons', this.generateClassName('StatusCheckboxOn')],
                                    children: ['check_box']
                                }),
                                createElement('div', {
                                    class: ['material-icons', this.generateClassName('StatusCheckboxOff')],
                                    children: ['check_box_outline_blank']
                                }),
                            ],
                        }),

                        this.itemStartElement = createElement('div', {
                            class: this.generateClassName('StartDate'),
                        }),

                        this.itemTitleInputElement = createElement('input', {
                            class: this.generateClassName('TitleInput'),
                            onkeypress: this.observeItemTitle,
                            onkeyup: this.observeItemTitle,
                            type: 'text',

                            onfocus: () => {
                                this.updateItemFocus(true)
                            },

                            onblur: () => {
                                this.updateItemFocus(false)
                                this.observeItemTitle()
                            },

                        }),

                        this.widgetsButtonsContainer = createElement('div', {
                            class: this.generateClassName('WidgetButtons'),
                        }),

                        this.editButtonElement = createElement('button', {
                            class: ['fa', this.generateClassName('RoundButton')],
                            onclick: this.openEdit,
                        }),

                        this.hideDescriptionButtonElement = createElement('button', {
                            class: ['fa', this.generateClassName('RoundButton')],
                            onclick: this.toggleHideDescription,
                        }),

                    ],
                }),

                createElement('div', {
                    class: this.generateClassName('Details'),
                    children: [

                        createElement('div', {
                            class: this.generateClassName('DetailsSide'),
                            children: [

                                this.durationInputElement = createElement('input', {
                                    class: this.generateClassName('DurationInput'),
                                    onkeydown: this.debounceUpdateDurationInYjs,
                                    onblur: this.setDurationInItem,
                                }),

                            ],
                        }),

                        createElement('div', {
                            class: this.generateClassName('DetailsContent'),
                            children: [

                                createElement('div', {
                                    class: this.generateClassName('Contacts'),
                                    children: [

                                        this.contactsContainer = createElement('div', {
                                            class: this.generateClassName('ContactsList'),
                                        }),

                                    ]
                                }),

                                this.itemProseMirrorElement = createElement('pbx-prosemirror', {
                                    class: ['RmProseMirror-Container', this.generateClassName('ProseMirror')],
                                }),

                                this.widgetsContainerElement = createElement('div', {
                                    class: this.generateClassName('Widgets'),
                                }),

                            ],
                        }),
                    ],
                }),
            ],
        })

    }

    watchUntilTrue (checkFunction, callback) {
        (function watch () {
            if (this.unmounted) return
            if (checkFunction() === true) callback()
            else setTimeout(watch, 500)
        }.bind(this))()
    }

    yjsWatchUntilTrue (field, callback) {
        this.watchUntilTrue(
            () => !!this.yItem.get(field),
            callback,
        )
    }

    initDetails () {
        // check if ProseMirror is already initialized
        if (this.proseMirrorInitDone) return
        this.proseMirrorInitDone = true

        this.itemProseMirrorElement.plugins = [
            ...proseMirrorYjsPlugins(
                this.yItem,
                this.updateItemFocus.bind(this),
                this.canEditRundown.bind(this),
            ),
        ]
    }

    connectedCallback () {
        clearTimeout(this.elementDestroyTimeout)
        this.unmounted = false

        this.appendChild(this.itemTypeElement)
        this.appendChild(this.itemContentElement)

        this.setItemIdAttributes()
        this.setItemOrderAttributes()
        this.yTitleToItemTitle()
        this.yStartToItemStart()

        this.placeModelType()
        this.updateStatusCheckbox()
        this.setDurationInItem()

        this.yItem.observe(this.yObserve)

        this.yjsWatchUntilTrue('title', () => {
            this.yItem.get('title').observe(this.observeYTitle)
        })

        this.yjsWatchUntilTrue('start', () => {
            this.yItem.get('start').observe(this.debouncePlaceItemStart)
        })

        this.yjsWatchUntilTrue('duration', () => {
            this.yItem.get('duration').observe(this.debouncePlaceItemDuration)
        })

        this.yjsWatchUntilTrue('widgets_data', () => {
            this.yItem.get('widgets_data').observe(this.yWidgetObserve)
        })

        this.yjsWatchUntilTrue('details', () => {
            this.initDetails()
        })
        this.yjsWatchUntilTrue('contacts', () => {
            for (const contact of this.yItem.get('contacts').values()) {
                this.addContact(contact)
            }
            this.yItem.get('contacts').observe(this.observeContact)
        })
    }

    addContact (contact) {

        let face = createElement('div', {
            class: this.generateClassName('face'),
            children: [
                createElement('span', {
                    class: this.generateClassName('bindings'),
                    textContent: contact.firstname.charAt(0) + contact.lastname.charAt(0),
                }),
                createElement('img', {
                    class: this.generateClassName('avatar'),
                    src: gravatar.url(contact.email, { s: '48', r: 'x', d: 'blank' }, true),
                    alt: (contact.firstname + ' ' + contact.lastname),
                })
            ]
        })
        const nameContainerChildren = [
            createElement('b', {
                class: this.generateClassName('name'),
                textContent: contact.firstname + ' ' + contact.lastname,
            })
        ]
        if (contact.email) {
            nameContainerChildren.push(createElement('a', {
                class: this.generateClassName('email'),
                href: 'mailto:' + contact.email,
                textContent: contact.email
            }))
        }
        if (contact.phone) {
            nameContainerChildren.push(createElement('a', {
                class: this.generateClassName('phone'),
                href: 'tel:' + contact.phone,
                textContent: contact.phone
            }))
        }

        let name = createElement('div', {
            class: this.generateClassName('nameContainer'),
            children: [
                createElement('span', {
                    children: nameContainerChildren
                })
            ]
        })

        let contactElement = this.findContactInDOM(contact.id)

        if (contactElement) {
            contactElement.removeChild(contactElement.firstChild) //remove face, https://stackoverflow.com/questions/13798796/what-is-the-best-way-to-empty-a-node-in-javascript
            contactElement.removeChild(contactElement.firstChild) //remove name
            contactElement.innerHtml = ''
        } else {
            contactElement = createElement('div', {
                class: this.generateClassName('contactItem'),
                'data-contact-id': contact.id,
            })
            this.contactsContainer.appendChild(contactElement)
        }

        contactElement.appendChild(face)
        contactElement.appendChild(name)

    }

    findContactInDOM (contactId) {
        return this.contactsContainer.querySelector(`[data-contact-id = "${contactId}"]`)
    }

    observeContact (event) {
        for (const key of event.keysChanged) {
            const contact = this.yItem.get('contacts').get(key)
            if (contact) this.addContact(contact)
            else this.deleteContact(key)
        }
    }

    deleteContact (contactId) {
        const contactItem = this.findContactInDOM(contactId)
        if (contactItem) this.contactsContainer.removeChild(contactItem)
    }

    disconnectedCallback () {
        this.elementDestroyTimeout = setTimeout(() => {
            delete this.proseMirrorInitDone
            this.unmounted = true
            this.destroyWidgets()
            delete this.currentModelTypeId
        }, 1000)

        // If id is empty observe is already destroyed
        if (this.yItem.get('id')) {
            this.yItem.unobserve(this.yObserve)
            this.yItem.get('title').unobserve(this.observeYTitle)
            this.yItem.get('start').unobserve(this.debouncePlaceItemStart)
            this.yItem.get('duration').unobserve(this.debouncePlaceItemDuration)
            this.yItem.get('widgets_data').unobserve(this.yWidgetObserve)
            this.yItem.get('contacts').unobserve(this.observeContact)
        }
    }

    set readOnly (readOnly) {
        this._readOnly = readOnly

        const {
            editButtonElement,
            itemTitleInputElement,
            durationInputElement,
        } = this

        editButtonElement.classList.toggle('fa-pencil', !readOnly)
        editButtonElement.classList.toggle('fa-eye', readOnly)

        if (readOnly) {
            editButtonElement.title = getTrans('rundownItem_view')
        } else {
            editButtonElement.title = getTrans('rundownItem_edit')
        }

        itemTitleInputElement.disabled = readOnly
        durationInputElement.disabled = readOnly
    }

    get readOnly () {
        return !!this._readOnly
    }

    generateClassName (name) {
        if (Array.isArray(name)) {
            return name.map(this.generateClassName).join(' ')
        }
        return 'RundownPrepsItem-' + name
    }

    generateCssVarName (name) {
        return '--rundown-item-' + name
    }

    setDurationInItem () {
        const { durationInputElement, yItem } = this

        const yDuration = yItem.get('duration')
        if (!yDuration) return

        const duration = parseInt(yDuration.toString())
        const parseSec = val => ('' + val).length === 1 ? '0' + val : val
        let parsedDurationString = '0:00'

        if (duration < 60) {
            parsedDurationString = '0:' + parseSec(duration)
        } else if (!isNaN(duration)) {
            const durationSeconds = duration % 60
            const durationMinutes = (duration - durationSeconds) / 60
            parsedDurationString = durationMinutes + ':' + parseSec(durationSeconds)
        }

        this.debounceDurationOverTime()

        if (document.activeElement !== durationInputElement) {
            durationInputElement.value = parsedDurationString
        }
    }

    hasItemStaticStart () {
        return this.yItem.get('static_start').toString() === 'true'
    }

    getStaticTime () {
        if (this.hasItemStaticStart()) {
            const yStart = this.yItem.get('start')
            if (yStart) return yStart.toString()
        }
        return null
    }

    findNextStaticTime () {
        let currentElement = this
        while ((currentElement = currentElement.nextElementSibling) != null) {
            if (currentElement instanceof RundownPrepItem) {
                const staticTime = currentElement.getStaticTime()
                if (staticTime !== null) return staticTime
            }
        }

        return this.yItem.doc.get('block').get('stop')
    }

    calculateOverTime () {
        const { itemStartElement, yItem } = this
        const yStart = yItem.get('start')
        if (yStart == null) {
            this.debounceOverTime()
            return
        }

        const nextStaticTime = this.findNextStaticTime()
        const nextStartTime = moment(nextStaticTime.toString())
        const nextStart = nextStartTime.format('HH:mm:ss')

        const start = moment(yStart.toString())
        const currentStart = start.format('HH:mm:ss')
        itemStartElement.classList.toggle('overTime', currentStart >= nextStart)
    }

    calculateDurationOverTime () {
        const { yItem, durationInputElement } = this

        const nextStaticTime = this.findNextStaticTime()
        const nextStartTime = moment(nextStaticTime.toString())
        const nextStart = nextStartTime.format('HH:mm:ss')

        const yStart = yItem.get('start')
        const start = moment(yStart.toString())
        const currentStart = start.format('HH:mm:ss')

        const yDuration = yItem.get('duration')
        if (!yDuration) return

        const duration = parseInt(yDuration.toString())

        const formattedDuration = moment.utc(duration * 1000).format('HH:mm:ss')

        const durationTime = moment.duration(formattedDuration)
        const startTime = moment.duration(currentStart)
        const stopTime = startTime.add(durationTime)
        const currentStop = moment.utc(stopTime.as('milliseconds')).format('HH:mm:ss')
        durationInputElement.classList.toggle('overTime', currentStop >= nextStart)
    }

    updateDurationInYjs () {
        const newValue = this.durationInputElement.value.replace(/\s+/g, '')
        const parsedNewValueToInt = parseInt(newValue)
        let parsedSeconds = 0

        switch (true) {
            case /^[0-9]*:[0-9]{0,2}$/.test(newValue):
                const [minutes, seconds] = newValue.split(':')
                parsedSeconds += parseInt(minutes) * 60
                parsedSeconds += parseInt(seconds || 0)
                break

            case /:/.test(newValue):
                return

            case !isNaN(parsedNewValueToInt) && isFinite(parsedNewValueToInt):
                parsedSeconds = parsedNewValueToInt
                break

            default:
                return
        }

        const yDuration = this.yItem.get('duration')
        yDuration.delete(0, yDuration.length)
        yDuration.insert(0, '' + parsedSeconds)
    }

    findItemModelType () {
        const itemModelTypeId = this.yItem.get('model_type_id')
        const itemModelTypes = window.itemModelTypes
        return itemModelTypes.find(modelType => modelType.id === itemModelTypeId) ||
          itemModelTypes.find(modelType => String(modelType.id) === String(itemModelTypeId))
    }

    toggleHideDescription () {
        if (this.hideDescriptionItem) {
            this.executeShowDescription()
        } else {
            this.executeHideDescription()
        }
    }

    executeShowDescription () {
        if (!this.hideDescriptionItem) return

        const {
            hideDescriptionButtonElement,
        } = this

        this.hideDescriptionItem = false
        hideDescriptionButtonElement.title = getTrans('hideDescription_Hide')
        hideDescriptionButtonElement.classList.add('fa-chevron-up')
        hideDescriptionButtonElement.classList.remove('fa-chevron-down')
        this.classList.remove(this.generateClassName('HideDescription'))
    }

    executeHideDescription () {
        if (this.hideDescriptionItem) return

        const {
            hideDescriptionButtonElement,
        } = this

        this.hideDescriptionItem = true
        hideDescriptionButtonElement.title = getTrans('hideDescription_Show')
        hideDescriptionButtonElement.classList.remove('fa-chevron-up')
        hideDescriptionButtonElement.classList.add('fa-chevron-down')
        this.classList.add(this.generateClassName('HideDescription'))
    }

    destroyWidgets () {
        const { widgets, registerWidgets } = this
        if (registerWidgets) {
            for (const widget of registerWidgets) {
                const { _uniqueId } = widget
                removeElement(widget._element)
                removeElement(widget._buttonElement)
                widgets.unRegisterWidget(_uniqueId)
                this.removeEventListener(widget._update_listener_name, widget._update_listener)
            }
        }
    }

    placeModelType () {
        const modelType = this.modelType = this.findItemModelType() || {}
        const modelTypeOptions = modelType.options || {}
        const modelTypeWidgets = modelType.widgets || []

        if (this.currentModelTypeId === modelType.id) {
            return
        }

        this.currentModelTypeId = modelType.id

        const itemColor = this.itemColor = modelTypeOptions.color || null
        this.style.setProperty(this.generateCssVarName('color'), itemColor)

        const talkItem = this.talkItem = !!modelTypeOptions.talk
        this.classList.toggle(this.generateClassName('TalkItem'), talkItem)

        const highlightItem = this.highlightItem = !!modelTypeOptions.highlight
        this.classList.toggle('highlight', highlightItem)

        const hideDescriptionItem = !!modelTypeOptions.hideDescription
        if (!('hideDescriptionItem' in this)) {
            // Revert hide description so the toggle will return the good value
            this.hideDescriptionItem = !hideDescriptionItem
            this.toggleHideDescription()
        } else {
            this.hideDescriptionItem = hideDescriptionItem
        }

        this.destroyWidgets()

        this.registerWidgets = []

        for (const { id: widgetId } of modelTypeWidgets) {
            const widgetButton = createElement('button', {
                class: this.generateClassName(['RoundButton', 'WidgetButton']),
                'data-widget-id': widgetId,
            })

            this.widgetsButtonsContainer.appendChild(widgetButton)

            this.widgets.getWidgetById(widgetId, 'rundown_item', this.ownerStationId)
                .then(dbWidget => {
                    const widget = { ...dbWidget, _buttonElement: widgetButton }
                    const widgetIcon = widget.icon || {}
                    const widgetSettings = widget.settings || { defaultOpen: false }

                    widgetButton.title = widget.title

                    switch (widgetIcon.type) {

                        case 'fa':
                            widgetButton.classList.add('fa', widgetIcon.name)
                            break

                        case 'img_svg':
                            fetch(widgetIcon.source, {})
                                .then(response => response.text())
                                .then(content => widgetButton.innerHTML = content)
                            break

                        case 'img_url':
                        case 'img_base64':
                            widgetButton.appendChild(
                                createElement('img', {
                                    alt: widget.title,
                                    src: widgetIcon.type === 'img_url'
                                        ? widgetIcon.source
                                        : widgetIcon.base64,
                                }),
                            )
                            break

                    }

                    this.registerWidgets.push(widget)
                    this.initWidget(widget)
                    widgetButton.addEventListener('click', () => {
                        const active = widget.active = !widget.active
                        widgetButton.classList.toggle('active', active)

                        if (widget._initStarted) {
                            widget._getElementPromise.then(iframe => {
                                iframe.classList.toggle('hide', !active)
                                if (active) this.executeShowDescription()
                            })
                        } else {
                            widget._initStarted = true
                            this.createWidget(widget).then(() => {
                                this.executeShowDescription()
                            })
                        }
                    })

                    if (widgetSettings.defaultOpen) {
                        setTimeout(() => {
                            widgetButton.click()
                        })
                    }
                })
        }

        this.generateWidgetButtonsLength()
    }

    generateWidgetButtonsLength () {
        const { modelType, widgetsButtonsContainer } = this
        const modelTypeWidgets = modelType.widgets || []

        const widgetLength = modelTypeWidgets.length
        const cssName = this.generateCssVarName('active-widgets')

        if (widgetLength === 0) {
            widgetsButtonsContainer.style.removeProperty(cssName)
        } else {
            widgetsButtonsContainer.style.setProperty(cssName, widgetLength)
        }
    }

    /**
     * @param event {YMapEvent}
     */
    yObserve (event) {
        const { keysChanged } = event
        const isKeyChanged = keysChanged.has.bind(keysChanged)

        if (isKeyChanged('order')) {
            this.setItemOrderAttributes()
            this.sortItems()
        }

        if (isKeyChanged('status')) {
            this.updateStatusCheckbox()
        }

        if (isKeyChanged('model_type_id')) {
            this.placeModelType()
        }
    }

    setItemIdAttributes () {
        const itemId = this.yItem.get('id')
        if (itemId) {
            this.setAttribute('data-id', itemId)
            this.id = getPrepIdName(itemId)
            this.itemId = itemId
        }
    }

    setItemOrderAttributes () {
        const orderValue = '' + this.yItem.get('order')
        const prefix = '0'.repeat(Math.max(0, 3 - orderValue.length))
        this.setAttribute('data-order', prefix + orderValue)
    }

    observeYTitle () {
        if (document.activeElement !== this.itemTitleInputElement) {
            this.debouncePlaceItemTitle()
        }
    }

    yTitleToItemTitle () {
        const yTitle = this.yItem.get('title')
        if (yTitle) {
            this.itemTitleInputElement.value = yTitle.toString()
        }
    }

    itemTitleToYTitle () {
        if (!this.yItem) return
        const yItemTitle = this.yItem.get('title')
        yItemTitle.delete(0, yItemTitle.length)
        yItemTitle.insert(0, this.itemTitleInputElement.value)
    }

    yStartToItemStart () {
        const yStart = this.yItem.get('start')
        if (yStart) {
            this.debounceOverTime()
            this.debounceDurationOverTime()
            const start = moment(yStart.toString()).tz(CONFIG.timezone)
            this.itemStartElement.innerText = start.format('HH:mm:ss')
            this.dispatchEvent(new CustomEvent('calculate-block-overtimes'))
        }
    }

    itemIsPlayed () {
        return this.yItem.get('status') === ITEM_STATE_PLAYED
    }

    itemIsPlaying () {
        return this.yItem.get('status') === ITEM_STATE_PLAYING
    }

    toggleStatusCheckbox () {
        if (this.readOnly) return
        this.updateStatusCheckbox()
        const newStatus = this.itemIsPlayed() ? 'scheduled' : 'played'
        cookieFetch('items/setstatus' + newStatus, {
            body: JSON.stringify({ id: this.yItem.get('id') }),
            headers: { 'Content-Type': 'application/json' },
            method: 'post',
        }).then()
    }

    updateStatusCheckbox () {
        const isItemPlayed = this.itemIsPlayed()
        const isItemPlaying = this.itemIsPlaying()
        const { itemStatusContainer, classList } = this

        let title = getTrans('setPlayStatusLabel_played')
        if (isItemPlayed) {
            title = getTrans('setPlayStatusLabel_scheduled')
        }

        itemStatusContainer.title = title
        itemStatusContainer.classList.toggle('checked', isItemPlayed)
        classList.toggle('done', isItemPlayed)
        classList.toggle('playing', isItemPlaying)
    }

    updateProseMirrorMenuPosition () {
        const { itemProseMirrorElement, scrollContainer } = this
        itemProseMirrorElement.menuPosition = getPmMenuPosition(itemProseMirrorElement, scrollContainer)
    }

    updateItemFocus (focus) {
        window.dispatchEvent(new CustomEvent(
            `prep-focus-${this.yItem.get('id')}`,
            { detail: { focus: focus } },
        ))

        if (focus) {
            this.updateProseMirrorMenuPosition()
            this.scrollContainer.addEventListener('scroll', this.updateProseMirrorMenuPositionDebounce)
        } else {
            this.scrollContainer.removeEventListener('scroll', this.updateProseMirrorMenuPositionDebounce)
        }
    }

    canEditRundown () {
        return !this.readOnly
    }

    openEdit () {
        this.dispatchEvent(new CustomEvent('open-edit'))
    }

    initWidget (widget) {
        const { yItem, widgets } = this
        const itemId = yItem.get('id')
        const uniqueWidgetId = widget._uniqueId = 'rundown_item_' + itemId + '_' + widget.id

        const toggleButtonHasContent = val => {
            if (typeof val === 'string' ) {
                val = val.replace(/<.*?>/g, '').trim() //strip any tags or empty lines
            }
            widget._buttonElement.classList.toggle('hasContent', !!val)
        }

        const updateContentToWidget = newValue => {
            toggleButtonHasContent(newValue)
            widgets.sendMessage(uniqueWidgetId, 'updateWidget', newValue)
        }

        widget._toggleButtonHasContent = toggleButtonHasContent
        widget._isFieldWidget = itemFieldRegex.test(widget.data_key)
        widget._itemValue = null

        if (widget._isFieldWidget) {
            widget._itemValue = this.watchItemValue(
                widget.data_key.replace(itemFieldRegex, ''),
                updateContentToWidget,
            )
            toggleButtonHasContent(widget._itemValue.value)
        } else {
            widget._update_listener = () => {
                const newValue = getWidgetData(yItem, widget.data_key).content
                updateContentToWidget(newValue)
            }
            widget._update_listener_name = `widgetDataUpdate_${widget.data_key}`
            this.addEventListener(widget._update_listener_name, widget._update_listener)
            toggleButtonHasContent(getWidgetData(yItem, widget.data_key).content)
        }
    }

    createWidget (widget) {
        const { yItem, rundownInfo, widgets } = this
        const itemId = yItem.get('id')
        const broadcast = rundownInfo.broadcast
        const stationId = rundownInfo.masterstation_id || window.CONFIG.station_id

        widget._getElementPromise = widgets.createWidgetFrame(
            widget._uniqueId,
            widget,
            {
                title: widget.title,
                name: widget.title + '_ rundown',
                readOnly: this.readOnly,
                type: widget.type,
                broadcastId: rundownInfo.broadcast.id,
                programId: rundownInfo.broadcast.program_id,
                itemId: itemId,
            },
            'rundown_item_' + itemId,
            (event, element) => {
                switch (event.action) {

                    case('height-update'):
                        element.style.setProperty(
                            this.generateCssVarName('widget-height'),
                            event.actionData.newHeight + 'px',
                        )
                        break

                    case('save'):
                        if (widget.data_key && !this.readOnly) {
                            const newContent = event.actionData.content

                            if (widget._isFieldWidget) {
                                widget._itemValue.update(newContent)
                            } else {
                                saveWidgetData(yItem, widget.data_key, {
                                    content: newContent,
                                })
                            }

                            widget._toggleButtonHasContent(newContent)
                        }
                        break

                    case('amount'):
                        if (widget.data_key) {
                            let amount = getWidgetData(yItem, widget.data_key).amount

                            switch (event.actionData.type) {
                                case('add'):
                                    amount += event.actionData.value
                                    break

                                case('subtract'):
                                    amount -= event.actionData.value
                                    break

                                case('set'):
                                    amount = event.actionData.value
                                    break
                            }

                            saveWidgetData(yItem, widget.data_key, { amount })
                        }
                        break
                }
            },
            () => {
                let content = null
                if (widget.data_key) {

                    if (widget._isFieldWidget && widget._itemValue) {
                        content = widget._itemValue.value
                    } else {
                        content = getWidgetData(yItem, widget.data_key).content
                    }
                }

                if (content instanceof Y.Text) {
                    content = content.toString()
                }

                return [content, {
                    itemId: itemId,
                    readOnly: this.readOnly,
                }]
            },
            {
                item: yItem,
                program: broadcast.program,
                broadcast: broadcast,
            },
            stationId,
            'rundown_item',
        ).then(element => {
            element.id = 'widget-' + widget.id
            element.classList.add(this.generateClassName('WidgetFrame'))

            this.widgetsContainerElement.append(element)

            widget._element = element
            widget.open = true

            return element
        })

        return widget._getElementPromise
    }

    observeYText (yText, lastKey, prevYObject, onChangeCallback) {
        const ctrl = {
            value: null,
            destroy: () => {
                yText.unobserve(observe)
            },
            update: (newValue) => {
                ctrl.value = newValue
                yText.delete(0, yText.toString().length)
                if (newValue != null) {
                    yText.insert(0, newValue)
                }
            },
        }

        const observe = _.debounce(() => {
            const newValue = yText.toString()
            ctrl.value = newValue
            onChangeCallback(newValue)
        }, 100)

        const setNewObserver = () => {
            ctrl.value = yText.toString()
            yText.observe(observe)
        }

        const observeNewYText = event => {
            if (event.keysChanged.has(lastKey)) {
                yText = event.target.get(lastKey)
                setNewObserver()
            }
        }

        setNewObserver()
        prevYObject.observe(observeNewYText)

        return ctrl
    }

    watchItemValue (name, onChangeCallback) {
        const path = name.split('.')
        let prevYObject, yObject = this.yItem, lastKey

        const ctrl = {
            destroy: () => void 0,
            update: (newValue) => void 0,
            value: null,
        }

        for (const key of path) {
            if (yObject instanceof Y.AbstractType) {
                prevYObject = yObject
                yObject = yObject.get(key)
                lastKey = key
            } else {
                console.error(`Name: "${name}" not found on rundown item '${this.yItem.get('id')}'`)
                return ctrl
            }
        }

        if (yObject instanceof Y.Text) {
            Object.assign(ctrl, this.observeYText(yObject, lastKey, prevYObject, onChangeCallback))

        } else if (prevYObject instanceof Y.Map) {
            ctrl.value = yObject

            const migrateToYText = (yText) => {
                ctrl.destroy()
                const newCtrl = this.observeYText(yText, lastKey, prevYObject, onChangeCallback)
                Object.assign(ctrl, newCtrl)
                onChangeCallback(ctrl.value)
            }

            const observe = event => {
                if (event.keysChanged.has(lastKey)) {
                    const newValue = prevYObject.get(lastKey)

                    if (newValue && newValue instanceof Y.Text) {
                        migrateToYText(newValue)
                    }

                    ctrl.value = newValue
                    onChangeCallback(newValue)
                }
            }

            prevYObject.observe(observe)
            ctrl.destroy = () => void prevYObject.unobserve(observe)
            ctrl.update = newValue => {
                const oldValue = prevYObject.get(lastKey)
                if (oldValue instanceof Y.Text) {
                    migrateToYText(oldValue)
                    ctrl.update(newValue)
                    return
                }

                ctrl.value = newValue
                if (oldValue != newValue || (!oldValue && !newValue)) {
                    prevYObject.set(lastKey, newValue)
                }
            }
        }

        return ctrl
    }

    yWidgetObserve (event) {
        for (const key of event.keysChanged.keys()) {
            this.dispatchEvent(new CustomEvent(`widgetDataUpdate_${key}`))
        }
    }

}

export const componentName = 'rm-rundown-prep-item'
customElements.define(componentName, RundownPrepItem)
